/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { API_URL } from "../../../Services/ApiService";
import { toastEmmit } from "../../../Helper/Toastr";
import EmailVerify from "../Email-Verify/EmailVerify";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useGoogleLogin } from "@react-oauth/google";

export default function Register({ reset, VerifyUserEmail }) {
  const navigate = useNavigate()
  useEffect(() => {
    resetForm();
  }, [reset]);

  const [TermsCondition, setTermsCondition] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfPassword, setShowConfPassword] = useState(false);
  const [loader, setLoader] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState("");
 
  useEffect(() => {
    // console.log(phoneNumber);
    formik.setFieldValue("phoneNumber", phoneNumber);
  }, [phoneNumber]);

  const formik = useFormik({
    initialValues: {
      fullName: "",
      email: "",
      phoneNumber: "",
      password: "",
      confirmPassword: "",
      country: ""
    },
    validationSchema: Yup.object({
      fullName: Yup.string().required("Full name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phoneNumber: Yup.string().required("Phone Number is required"),
      password: Yup.string().required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      setLoader(true);
      // console.log(values);
      const formdata = {
        fullName: values.fullName,
        email: values.email,
        password: values.password,
        confirm_password: values.confirmPassword,
        phone: values.phoneNumber,
        country: values.country,
      };

      axios.post(API_URL.REGISTER, formdata).then(
        (res) => {
          console.log(res);
          setLoader(false);
          if (res?.data?.status === true) {
            sendEmail(values.email);
            // toastEmmit("success", res?.data?.message);
            // document.getElementById("openloginModal").click();
            document.getElementById("openverifymodal").click();
            resetForm();
          } else toastEmmit("error", res?.data?.message);
        },
        (err) => {
          setLoader(false);
          console.log(err?.response?.data?.message);
          toastEmmit("error", err?.response?.data?.message);
        }
      );
    },
  });

  function resetForm() {
    formik.resetForm();
    setPhoneNumber("")
  }

  function sendEmail(email) {
    VerifyUserEmail(email);
  }

  const [user, setUser] = useState([]);
 
  const login = useGoogleLogin({
    onSuccess: (codeResponse) =>{ setUser(codeResponse);console.log(codeResponse)},
    onError: (error) => console.log("Login Failed:", error),
  });

  useEffect(() => {
    if (user && user?.access_token) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res);  
          resetForm();
          if (res.data?.verified_email) {
            const setdata = {
              fullName:res?.data?.name,
              email: res.data?.email,
              socialkey: res.data?.id,
              logintype: "google",
            };
            CallLoginApi(setdata);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  function CallLoginApi(values) {
    setLoader(true);
    axios.post(API_URL.LOGIN, values).then(
      (res) => {
        console.log(res);
        setLoader(false);
        if (res?.data?.status === true) {   
          if (res?.data?.data?.isEmailverified) {
            toastEmmit("success", res?.data?.message);
            localStorage.clear()
            localStorage.setItem("token", res?.data?.data?.accessToken);
            localStorage.setItem("count", res?.data?.data?.cartCount);
            localStorage.setItem("user", res?.data?.data?.fullName); 
            localStorage.setItem("profile", res?.data?.data?.profile);
            resetForm();
            const path = window.location.href;
            const newwe = path.split("#");
            navigate(newwe[1]); 
            
            document.getElementById("RegCloseModal").click();
          }
        } else toastEmmit("error", res?.data?.message);
      },
      (err) => {
        console.log(err?.response?.data?.message);
        setLoader(false);
        toastEmmit("error", err?.response?.data?.message);
      }
    );
  }

  return (
    <div>
      <div
        className="modal fade index"
        id="staticBackdrop"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetForm}
                id="RegCloseModal"
              />
            </div>
            <div className="modal-body popup border-0">
              <h4>Hi, Welcome Back!</h4>
              <p>
                Already have an account?
                <span className="highlight">
                  <a
                    href="#"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                    id="openloginModal"
                  >
                    {" "}
                    Sign in
                  </a>
                </span>
              </p>
              <form onSubmit={formik.handleSubmit} className="pt-10">
                {/* <form onSubmit={handleSubmit} className="pt-10"> */}
                <div className="row justify-content-center">
                  <div className="col-xl-11 col-lg-11 col-md-12">
                    <div
                      className="tp-register__input-box"
                      style={{ marginBottom: 10 }}
                    >
                      <label htmlFor="email">
                        Full name<sup className="error">*</sup>
                      </label>
                      <input
                        type="text"
                        id="fullName"
                        name="fullName"
                        placeholder="Enter Full name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.fullName}
                      />
                      {formik.touched.fullName && formik.errors.fullName && (
                        <div className="error mt-1">
                          {formik.errors.fullName}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-xl-11 col-lg-11 col-md-12">
                    <div
                      className="tp-register__input-box"
                      style={{ marginBottom: 10 }}
                    >
                      <label htmlFor="email2">
                        Email<sup className="error">*</sup>
                      </label>
                      <input
                        type="email"
                        id="email2"
                        name="email"
                        placeholder="Enter Email Address"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.email}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="error mt-1">{formik.errors.email}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-xl-11 col-lg-11 col-md-12">
                    <div
                      className="tp-register__input-box"
                      style={{ marginBottom: 10 }}
                    >
                      <label htmlFor="phoneNumber">
                        Phone Number<sup className="error">*</sup>
                      </label>
                      
                      <PhoneInput
                        country={"us"}
                        value={phoneNumber}
                        onChange={(e, country) => {
                          const formattedNumber = `+${e.replace(/\D/g, "")}`;
                          setPhoneNumber(formattedNumber);
                          formik.setFieldValue("country", country?.name);
                        }}
                      />

                      {/* <input
                        type="number"
                        className="no-spinner"
                        id="phoneNumber"
                        name="phoneNumber"
                        placeholder="Enter Phone Number"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.phoneNumber}
                        onWheel={e => e.target.blur()}
                      /> */}
                      {formik.touched.phoneNumber &&
                        formik.errors.phoneNumber && (
                          <div className="error mt-1">
                            {formik.errors.phoneNumber}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="col-xl-11 col-lg-11 col-md-12">
                    <div
                      className="tp-register__input-box"
                      style={{ marginBottom: 10 }}
                    >
                      <label htmlFor="password">
                        Password<sup className="error">*</sup>
                      </label>
                      <input
                        type={showPassword ? "text" : "password"}
                        id="password"
                        name="password"
                        placeholder="Create password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                      />
                      <i
                        className={
                          showPassword
                            ? "fa-regular fa-eye"
                            : "fa-regular fa-eye-slash"
                        }
                        onClick={() => setShowPassword(!showPassword)}
                        style={{ cursor: "pointer" }}
                      />
                      {formik.touched.password && formik.errors.password && (
                        <div className="error mt-1">
                          {formik.errors.password}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-xl-11 col-lg-11 col-md-12">
                    <div
                      className="tp-register__input-box"
                      style={{ marginBottom: 10 }}
                    >
                      <label htmlFor="password">
                        Confirm Password<sup className="error">*</sup>
                      </label>
                      <input
                        type={showConfPassword ? "text" : "password"}
                        id="confirmPassword"
                        name="confirmPassword"
                        placeholder="Confirm password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.confirmPassword}
                      />
                      <i
                        className={
                          showConfPassword
                            ? "fa-regular fa-eye"
                            : "fa-regular fa-eye-slash"
                        }
                        onClick={() => setShowConfPassword(!showConfPassword)}
                        style={{ cursor: "pointer" }}
                      />
                      {formik.touched.confirmPassword &&
                        formik.errors.confirmPassword && (
                          <div className="error mt-1">
                            {formik.errors.confirmPassword}
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-xl-12 col-lg-12 col-md-12 left-section">
                      <div className="tp-contact-4__comment-agree label-2 pb-20">
                        <div className="form-check-box left">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="flexCheckDefault"
                            name="flexCheckDefault"
                            checked={TermsCondition}
                            onChange={(e) => {
                              setTermsCondition(e.target.checked);
                            }}
                          />
                          <label
                            className="form-check-label text-theme"
                            htmlFor="flexCheckDefault"
                          >
                            By hitting the "Register" button, you agree to the{" "}
                            <span> Terms conditions &amp; Privacy Policy </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                      <button
                        className={`tp-btn-lg large head tp-contact-4__btn w-100 popup ${
                          loader ? "disabled" : ""
                        }`}
                        type="submit"
                        disabled={!TermsCondition}
                      >
                        {loader ? (
                          <span>
                            <i className="fa fa-spinner fa-spin fa-fw"></i>
                          </span>
                        ) : (
                          "Register"
                        )}
                      </button>
                    </div>
                    <div className="right text-right d-none">
                      <Link
                        data-bs-toggle="modal"
                        data-bs-target="#emailverify"
                        id="openverifymodal"
                      >
                        Verify Email
                      </Link>
                    </div>
                  </div>
                  <div className="row pt-30 pb-40">
                    <div className="col-xl-6 col-lg-6 col-md-6">
                      <img
                        className="w-100"
                        src="assets/img/blog/google_register.png"
                        alt=""
                        onClick={login}
                        style={{ cursor: "pointer" }}
                      />
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 respons-mt">
                      <img
                        className="w-100"
                        src="assets/img/blog/google2.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
